import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const ArrowUpDoubleIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', filled, ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        ref={forwardedRef}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <title>{props.title}</title>
        <path
          clipRule="evenodd"
          d="M12.0001 7.75788L16.9498 12.7076L18.3641 11.2934L12.0001 4.92944L5.63614 11.2934L7.05035 12.7076L12.0001 7.75788ZM12.0001 13.1719L16.9498 18.1216L18.3641 16.7074L12.0001 10.3434L5.63614 16.7074L7.05035 18.1216L12.0001 13.1719Z"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    );
  },
);

export default ArrowUpDoubleIcon;
